class LayoutSwitcher extends HTMLUListElement {
  constructor () {
    super()

    this.state = {
      device: this.dataset.device,
    }

    this.els = {
      trigger: this.querySelectorAll('[data-layout-switcher-el="trigger"]'),
    }

    this.externalEls = {
      grid: document.querySelector('[data-layout-switcher-external-el="grid"]'),
    }

    this.setupListeners()
  }

  setupListeners () {
    this.els.trigger.forEach(trigger => {
      trigger.addEventListener('click', this.handleTriggerClick.bind(this))
    })
  }

  handleTriggerClick (e) {
    const view = e.target.dataset.view

    this.currentView = view
  }

  async setView () {
    if (!this.externalEls.grid) return

    const view = this.state.view
    const viewport = this.state.device

    let classToAdd = `medium-up-${view}`
    if (viewport === 'mobile') {
      classToAdd = `small-up-${view}`
    }

    const prefix = viewport === 'mobile' ? 'small-up-' : 'medium-up-'
    this.externalEls.grid.classList.remove(
      ...Array.from(this.externalEls.grid.classList).filter(c => c.startsWith(prefix))
    )
    this.externalEls.grid.classList.add(classToAdd)

    this.els.trigger.forEach(trigger => {
      const isPressed = trigger.dataset.view === view
      trigger.setAttribute('aria-pressed', isPressed)
    })

    await this.postCartAttribute()
  }

  async postCartAttribute () {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            [this.itemKey]: this.currentView,
          },
        }),
      })

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }
    } catch (error) {
      console.error('Failed to update cart attribute:', error)
    }
  }

  get itemKey () {
    return `_collection-view-${this.state.device}`
  }

  get currentView () {
    return this.state.view
  }

  set currentView (view) {
    this.state.view = view
    this.setView()
  }
}

if (!customElements.get('layout-switcher')) {
  customElements.define('layout-switcher', LayoutSwitcher, {
    extends: 'ul',
  })
}
